"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toaster = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_transition_group_1 = require("react-transition-group");
var react_redux_1 = require("react-redux");
var Types = require("types");
require("./style.scss");
var toastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var message_1 = require("./message");
var mapStateToProps = function (state) { return ({
    user: state.auth.current.user,
    messages: state.toast.messages
}); };
var mapDispatchToProps = function (dispatch) { return ({
    removeToast: function (uuid) { return dispatch(toastActions.removeToast(uuid)); },
    dispatch: dispatch
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), recompose_1.pure);
var timeout = { exit: 500, enter: 1000 };
var classNames = {
    appear: 'sok-toast-appear',
    appearActive: 'sok-toast-appear-active',
    enter: 'sok-toast-enter',
    enterActive: 'sok-toast-enter-active',
    exit: 'sok-toast-exit',
    exitActive: 'sok-toast-exit-active'
};
var PureToaster = function (props) { return (React.createElement(react_transition_group_1.TransitionGroup, { className: 'sok-toast-container' }, props.user.isSome()
    ? props.messages.slice(0, 5).map(function (message) { return (React.createElement(react_transition_group_1.CSSTransition, { key: "toast-".concat(message.uuid), timeout: timeout, classNames: classNames },
        React.createElement(message_1.ToastMessage, { removeToast: props.removeToast, message: message, dispatch: props.dispatch }))); })
    : [])); };
exports.Toaster = enhance(PureToaster);
